module.exports = __webpack_public_path__ + "img/medalla.5701843d.svg";